/* src/app/shared/components/flow-search-input/flow-search-input.component.scss */
.flow-search-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}
.flow-search-input {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 4px 0 12px;
  height: 40px;
  background-color: #f4f4f5;
  border: 1px solid transparent;
  border-radius: 8px;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease;
}
.flow-search-input .icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  width: 16px;
  flex-shrink: 0;
}
.flow-search-input .icon {
  height: 16px;
  width: 16px;
  filter: brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(279%) hue-rotate(202deg) brightness(95%) contrast(85%);
}
.flow-search-input .search-field {
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: #18181b;
  font-family: "Poppins-Regular";
  font-size: 14px;
}
.flow-search-input .search-field::placeholder {
  color: #71717a;
}
.flow-search-input .clear-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.flow-search-input .clear-button .icon {
  height: 10px;
  width: 10px;
}
.flow-search-input .clear-button:hover .icon {
  filter: none;
}
.flow-search-input .search-button {
  flex-shrink: 0;
}
.flow-search-input:not(.disabled):hover {
  background-color: #e4e4e7;
}
.flow-search-input.focused {
  background-color: #ffffff;
  border-color: #5580dc;
  box-shadow: 0 0 0 3px #a2c1ee;
}
.flow-search-input.typing {
  background-color: #fafafa;
  border-color: transparent;
  box-shadow: none;
}
.flow-search-input.error {
  background-color: #f4f4f5;
  border-color: #b91c1c;
  box-shadow: 0 0 0 2px rgba(185, 28, 28, 0.16);
}
.flow-search-input.error:not(.disabled):hover {
  background-color: #e4e4e7;
}
.flow-search-input.error.focused {
  box-shadow: 0 0 0 3px #fca5a5;
}
.flow-search-input.error.typing {
  background-color: #ffffff;
}
.flow-search-input.error.typing:not(.disabled):hover {
  background-color: #fafafa;
}
.flow-search-input.disabled {
  background-color: #f4f4f5;
  cursor: not-allowed;
}
.flow-search-input.disabled .icon {
  filter: brightness(0) saturate(100%) invert(65%);
}
.flow-search-input.disabled .search-field {
  color: #a1a1aa;
  cursor: not-allowed;
}
.flow-search-input.disabled .search-field::placeholder {
  color: #a1a1aa;
}
.flow-search-input-label {
  color: #18181b;
}
/*# sourceMappingURL=flow-search-input.component.css.map */
